/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Library_Equity_ResearchInputs */

const en_landing_library_equity_research = /** @type {(inputs: Landing_Library_Equity_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equity Research archive`)
};

/**
* | output |
* | --- |
* | "Equity Research archive" |
*
* @param {Landing_Library_Equity_ResearchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_library_equity_research = /** @type {((inputs?: Landing_Library_Equity_ResearchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Library_Equity_ResearchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_library_equity_research(inputs)
});